import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import { useGetProductById } from "../../api/product";
import { InfoCard } from "../../components/cards/info-card";
import WithAuth from "../../hoc/WithAuth";
import { User } from "lucide-react";
import { Icons } from "../../assets/images/icons";

const BranchDetailPage: React.FC = () => {
  const { id: product_id } = useParams();

  const [productData, setProductData] = useState<any>(null);

  /** API hooks */
  const { data: product, isLoading } = useGetProductById(product_id!);

  const {
    createdBy,
    createdAt,
    updatedBy,
    updatedAt,
    category,
    productName,
    variety,
    unitOfMeasurementName,
    description,
  } = product?.data?.data || {};

  useEffect(() => {
    if (product?.data?.data) {
      setProductData(product.data.data);
    }
  }, [product]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!productData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <h2 className="text-xl font-semibold text-gray-600">Order not found</h2>
      </div>
    );
  }

  const metaData = [
    {
      title: "Created By",
      value: createdBy,
      icon: User,
    },
    {
      title: "Created At",
      value: createdAt,
      icon: Icons.calendar03Icon,
    },
    {
      title: "Updated By",
      value: updatedBy || "N/A",
      icon: User,
    },
    {
      title: "Updated At",
      value: updatedAt || "N/A",
      icon: Icons.arrowReloadIcon,
    },
  ];

  const productInfo = [
    {
      title: "Category",
      value: category,
    },
    {
      title: "Product Name",
      value: productName,
    },
    {
      title: "Variety",
      value: variety,
    },
    {
      title: "Measurement Unit",
      value: unitOfMeasurementName,
    },
    {
      title: "Description",
      value: description,
    },
  ];

  return (
    <div
      className="bg-white px-4 md:px-8 py-8 h-screen"
      style={{ fontFamily: "Poppins" }}
    >
      {/** Combined Information Section */}
      <div className="bg-white border border-[#E6EEF6] rounded-2xl p-6 w-full">
        {/** System Information */}
        <h2 className="text-base font-medium text-black mb-6">
          System Information
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-6 mb-4">
          {metaData.map((meta) => (
            <InfoCard title={meta.title} value={meta.value} icon={meta?.icon} />
          ))}
        </div>
      </div>

      {/** Product Information Section */}
      <div className="bg-white border border-[#E6EEF6] rounded-2xl p-6 w-full mt-3">
        {/** Product Information */}
        <h2 className="text-base font-medium text-black mb-6">
          Product Information
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-4 gap-x-6 mb-4">
          {productInfo.map((product) => (
            <InfoCard title={product.title} value={product.value} />
          ))}
        </div>
      </div>

      {/** Tags Section */}
      <div className="bg-white border border-[#E6EEF6] rounded-2xl p-6 w-full mt-3">
        {/** Product Tags & Attributes Information */}
        <h2 className="text-base font-medium text-black mb-6">
          Product Tags & Attributes
        </h2>

        <div className="flex flex-col m-auto justify-center items-center gap-y-4 gap-x-6 mb-4">
          <img src={Icons.noDataIcon} alt="no data" className="h-32 w-32" />
          No tags available
        </div>
      </div>
    </div>
  );
};

export default WithAuth(BranchDetailPage);
